/* eslint-disable prettier/prettier */
import sirepAPI from "@/api/sirepApi";

export const loadDepartments = async()=>{
    try {
        const {data} = await sirepAPI.get("/recintoPenitenciario/departments_names")  
        return {data} 
    } catch (error) {
        return {message:error}
    }
}

export const loadProvinces= async({ commit }, department)=>{
    // console.log('actionsLoadProvinces', department)
    try {
        const {data} = await sirepAPI.get("/recintoPenitenciario/provinces_names/" + department)  
        //commit("listProvinces", {data})
        return {data} 
    } catch (error) {
        return {message:error}
    }
}

export const loadMunicipalities = async({ commit }, data)=>{

    const {department, province} = data
    // console.log('en actions', data)
    // console.log('en actions', department, province)
    try {
        const {data} = await sirepAPI.get("/recintoPenitenciario/municipalities_names/" + department + "/" + province)
        // commit("listMunicipalities",{data})
        return {data}
    } catch (error) {
        return {message:error}
    }
}

// Cargar la lista de recintos penitenciarios de la api BD
export const loadPenitentiaries = async({ commit }) => {
    try {
        const {data} = await sirepAPI.get("recintoPenitenciario/read_penitentiary")
        // console.log(data)
        commit('cleanPenitentiary')
        return {data}
    } catch (error) {
        return {message:error}
    }
}

// Creamos un nuevo registro de recinto penitenciario
export const createPenitentiary = async ({ commit }, dataToSave) => {
    try {
        // const userLogged = 1
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        
        const {data} = await sirepAPI.post("recintoPenitenciario/create_penitentiary/"+ userLogged, dataToSave)
        //llamamos a la mutacion mediante un commit
        // commit('addPenitentiary', dataToSave)
        return {data} 

    } catch (error) {
        return {message:error}
    }
}

// Leemos un registro de recinto penitenciario
export const infoPenitentiary = async ({ commit }, id_recinto_penitenciario) => {
    try {
        const {data} = await sirepAPI.get("recintoPenitenciario/info_penitentiary/"+id_recinto_penitenciario)
        commit('infoPenitentiary', data)
        return data
    } catch (error) {
        return {message:error}
    }
}

export const updatePenitentiary = async ({ commit }, dataToSave) => {
    try {
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepAPI.post("recintoPenitenciario/update_penitentiary/"+ userLogged, dataToSave)
        // commit('addPenitentiary', dataToSave)
        return {data} 
    } catch (error) {
        return {message:error}
    }
}

export const deletePenitentiary = async ({ commit }, dataToSave) => {
    try {
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const dataToEliminate = { 'id_recinto_penitenciario': dataToSave }
        // console.log(dataToEliminate)
        // console.log('actions deletePenitentiary', dataToSave)
        const {data} = await sirepAPI.post("recintoPenitenciario/delete_penitentiary/"+ userLogged, dataToEliminate)
        // commit('addPenitentiary', dataToSave)
        return {data} 
    } catch (error) {
        return {message:error}
    }
}

export const incrementarValor = async ({commit}) => {
    try {
        commit('incrementar')
    } catch (error) {
        return {message:error}
    }
}

export const incrementarValorPor = async ({commit}, data) => {
    try {
        commit('incrementarPor', data)
    } catch (error) {
        return {message:error}
    }
}